"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = Pagination;

var _react = _interopRequireWildcard(require("react"));

var _StripesTheme = require("../../StripesTheme.js");

var _react2 = require("../..");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@zebra-fed/icons/Keyboard/index.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    margin: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    padding: 0px ", "px 0px ", "px;\n    min-width: ", "px;\n    height: ", "px;\n    line-height: ", "px;\n    text-align: center;\n    outline: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding-top: ", "px;\n    display:flex;\n    justify-content: flex-end;\n    overflow-wrap: break-word;\n    flex-wrap: wrap;\n    list-style-type: none; \n    font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PaginationWrapper = _styledComponents["default"].ul(_templateObject(), function (props) {
  return props.spacingObj.basePadding;
}, function (props) {
  return props.fontFamilyObj;
});

var PageItem = _styledComponents["default"].li(_templateObject2(), function (props) {
  return props.spacingObj.basePadding / 2;
}, function (props) {
  return props.colorObj.border;
}, function (props) {
  return props.selected ? 'white' : props.colorObj.border;
}, function (props) {
  return props.selected ? '#007CB0' : 'white';
}, function (props) {
  return props.spacingObj.fontFamily;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.spacingObj.basePadding / 4;
}, function (props) {
  return props.spacingObj.basePadding / 4;
}, function (props) {
  return props.spacingObj.basePadding * 3;
}, function (props) {
  return props.spacingObj.basePadding * 3;
}, function (props) {
  return props.spacingObj.basePadding * 3;
});
/**
 * Pagination is used to switch between pages of content.
 * @example import { Pagination } from '@desktop/react';
 */


function Pagination(_ref) {
  var callback = _ref.callback,
      pageSize = _ref.pageSize,
      dataSize = _ref.dataSize,
      numClicked = _ref.numClicked,
      type = _ref.type;
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[type];
  var colors = context.getColors()[type];
  var midpt = 3; // the amount of pages to show at one time divided by 2.

  var lowerbound = 0; // initial value of the most left page

  if (numClicked - midpt > 0) {
    // if (true) then shift the pages visible. 
    lowerbound = numClicked - midpt;
  }

  var count = Math.ceil(dataSize / pageSize);
  var pages = [];
  var modifiedBound = lowerbound; // this ensures that if there are not enough page count elements
  // to match what is expected, then more are added. i.e. if at the highest page count, we dont want to remove pages because nothing new is showing.

  while (count - (modifiedBound + 1) < midpt * 2 - 1) {
    if (modifiedBound <= 1) break; // prevent sub 0 pages.

    modifiedBound--;
  }

  var _loop = function _loop(i) {
    var selected = numClicked === i - 1;
    pages.push( /*#__PURE__*/_react["default"].createElement(PageItem, {
      colorObj: colors,
      spacingObj: spacing,
      selected: selected,
      key: i - 1,
      onClick: function onClick() {
        return callback(i - 1);
      }
    }, i));
  };

  for (var i = modifiedBound + 1; i <= (lowerbound + midpt * 2 > count ? count : lowerbound + midpt * 2); i++) {
    _loop(i);
  }

  function clickAction(type) {
    if (type === 'left' && numClicked > 0) {
      callback(numClicked - 1);
    } else if (type === 'right' && numClicked < count - 1) {
      callback(numClicked + 1);
    }
  }

  return /*#__PURE__*/_react["default"].createElement(PaginationWrapper, {
    spacingObj: spacing,
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: spacing.basePadding,
      lineHeight: "".concat(spacing.basePadding * 4, "px"),
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    size: 20,
    color: 'grey',
    category: 'keyboard',
    name: 'left',
    onClick: function onClick() {
      return clickAction('left');
    }
  })), /*#__PURE__*/_react["default"].createElement(PageItem, {
    colorObj: colors,
    spacingObj: spacing,
    style: numClicked > midpt ? {
      visibility: true
    } : {
      visibility: "hidden"
    },
    onClick: function onClick() {
      return callback(0);
    }
  }, 1), /*#__PURE__*/_react["default"].createElement("li", {
    style: {
      minWidth: '12px',
      minHeight: '12px'
    }
  }), pages, /*#__PURE__*/_react["default"].createElement("li", {
    style: {
      minWidth: '12px',
      minHeight: '12px'
    }
  }), /*#__PURE__*/_react["default"].createElement(PageItem, {
    colorObj: colors,
    spacingObj: spacing,
    style: count > midpt + numClicked ? {
      visibility: true
    } : {
      visibility: "hidden"
    },
    onClick: function onClick() {
      return callback(count - 1);
    }
  }, count), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: spacing.basePadding,
      lineHeight: "".concat(spacing.basePadding * 4, "px"),
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    size: 20,
    color: 'grey',
    category: 'keyboard',
    name: 'right',
    onClick: function onClick() {
      return clickAction('right');
    }
  })));
}

Pagination.propTypes = {
  callback: _propTypes["default"].func,
  pageSize: _propTypes["default"].number,
  dataSize: _propTypes["default"].number,
  numClicked: _propTypes["default"].number
};
Pagination.defaultProps = {
  type: 'pagination',
  callback: function callback() {
    return false;
  },
  pageSize: 2,
  dataSize: 0,
  numClicked: 0
};